import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSettingsIconSecondary from './svgs/SettingsIconSecondary.js';
import SvgSettingsIcon from './svgs/SettingsIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var settingsIcon = (props => useIcon(SvgSettingsIcon, SvgSettingsIconSecondary, props));

export { settingsIcon as default };
